import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive  } from '@angular/router';


@Component({
  selector: 'app-footer',
  imports: [MatToolbarModule, CommonModule,RouterLink ],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  standalone: true,
  
})
export class Footer {

  footerLinks = [
    { title: 'About Us', page: '/about' },
    { title: 'Contact', page: '/contact' },
    { title: 'Privacy', page: '/privacy' }
  ];

}
